/**
 * Google Analytics 4 esemény-helper (property: G-T832WZXNC2).
 *
 * A base gtag snippet a /public/index.html-ben töltődik Consent Mode v2
 * alapértelmezésekkel. Ez a wrapper soha nem dob hibát, ha a gtag nincs
 * betöltve (pl. adblock), az esemény egyszerűen elmarad.
 */
export const trackGaEvent = (name, params = {}) => {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', name, params);
  } catch (_e) {
    /* never crash UI on tracking failure */
  }
};
